import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useAddTemporaryLicense = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .post('/api/License/TemporaryLicense', model)
        .then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([LicenseQueryKey.Info], (old) => {
                if (!old)
                    return old;
                return Object.assign(Object.assign({}, old), { temporaryLicenses: [...(old.temporaryLicenses || []), result] });
            });
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { addTemporaryLicense: mutateAsync, isSaving: isLoading };
};
export default useAddTemporaryLicense;
